import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

const platform = { platform: { component: 'discovery-sdk' } };

export const showRecommendations = new UFOExperience('show-recommendations', {
	type: ExperienceTypes.Load,
	performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	...platform,
});

export const dismiss = new UFOExperience('dismiss', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
	...platform,
});

export const showReasons = new UFOExperience('show-reasons', {
	type: ExperienceTypes.Operation,
	performanceType: ExperiencePerformanceTypes.Custom,
	...platform,
});
